<script setup lang="ts">
import { ToccoWebinarFieldsFragment } from '~/api/graphql/generated'
import { Link } from '~/types'
import { useSchemaToccoBase } from '~/composables/useSchemaToccoBase'

useNoCache()

const props = withDefaults(
  defineProps<{
    entity: ToccoWebinarFieldsFragment
    breadcrumbs?: Link[]
  }>(),
  {
    breadcrumbs: () => [],
  },
)

// Add schema.org JSON-LD structured data
useSchemaToccoBase(props.entity, 'webinar')
</script>

<template>
  <ToccoBase :entity="entity" :breadcrumbs="breadcrumbs" />
</template>
